import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProcessStepper from "../../../../components/stepperprocess/ProcessStepper";

const MemberDocumentProcess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const member = location.state?.member;

  if (!member) {
    return (
      <div className="container py-4">
        <p>
          No company selected.{" "}
          <button className="btn btn-link" onClick={() => navigate(-1)}>
            Go back
          </button>
        </p>
      </div>
    );
  }
  const handleApprove = () => {
    navigate("/personal-details", {
      state: { company: member, userType: "Member" },
    });
  };

  return (
    <div className="" style={{ minHeight: "100vh" }}>
      <div>
        <ProcessStepper currentStep={0} userType={"Member"} />
      </div>
      <div className="flex-grow-1">
        {/* Your Company Details Card */}
        <div className="p-4 shadow rounded bg-white">
          <div className="d-flex">
            <div className="col-6">
              <h5>
                Brand or Whitelabel:{" "}
                <span className="text-muted">{member.member_firm_name}</span>
              </h5>
              <p>
                Business Type: <span className="text-muted">{member?.member_business_type}</span>
              </p>
              <p>
                Address:{" "}
                <span className="text-muted">{member.member_firm_address}</span>
              </p>
            </div>

            <div className="col-6">
              <p style={{fontSize:'16px'}}>Shop or Office Image</p>
              <img
                src={
                  member.member_company_image ||
                  "https://images.pexels.com/photos/3182761/pexels-photo-3182761.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                }
                alt="Company"
                className="img-fluid rounded shadow"
                
              />
            </div>
          </div>
          <div className="d-flex justify-content-end gap-3 mt-4">
            <button className="btn btn-primary px-4" onClick={handleApprove}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberDocumentProcess;
